/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberPaymentStepError {
  boxId?: string;
  email?: string;
  extraData?: string;
  lastMessage?: string;
  lr?: string;
  origin?: string;
  paymentResponseMessageType?: string;
  paymentResponseMessageTypeId?: number;
  paymentRoundId?: number;
  subscriberId?: number;
  subscriberStatus?: string;
  tid?: string;
  transactionStatusName?: string;
}
